import styled from '@emotion/styled';

import { spacing, transitions } from '../tokens';

export const spec = {
  track: { width: 40, height: 20, padding: 2 },
  thumb: { size: 16 },
  off: { track: '#D9D9D9', thumb: '#8C8C8C' },
  on: { track: '#000FFF', thumb: '#E5E7FF' },
  disabled: { track: '#E8E8E8', thumb: '#C1C1C1' },
  focus: '#000FFF',
  label: '#282828',
  labelDisabled: '#B4B4B4',
} as const;

const thumbTravel = spec.track.width - spec.track.padding * 2 - spec.thumb.size;

type StateProps = { $checked: boolean; $disabled: boolean };

export const SwitchRoot = styled('label')<{ $disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.xs};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

export const HiddenInput = styled('input')`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;

  &:focus-visible + span {
    outline: 3px solid ${spec.focus};
    outline-offset: 2px;
  }
`;

export const Track = styled('span', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<StateProps>`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: ${spec.track.width}px;
  min-width: ${spec.track.width}px;
  height: ${spec.track.height}px;
  padding: 0 ${spec.track.padding}px;
  border-radius: 1000px;
  background-color: ${({ $checked, $disabled }) => {
    if ($disabled) return spec.disabled.track;
    return $checked ? spec.on.track : spec.off.track;
  }};
  transition: background-color ${transitions.base};
`;

export const Thumb = styled('span', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<StateProps>`
  display: block;
  width: ${spec.thumb.size}px;
  height: ${spec.thumb.size}px;
  border-radius: 50%;
  background-color: ${({ $checked, $disabled }) => {
    if ($disabled) return spec.disabled.thumb;
    return $checked ? spec.on.thumb : spec.off.thumb;
  }};
  transform: translateX(${({ $checked }) => ($checked ? thumbTravel : 0)}px);
  transition: transform ${transitions.base},
    background-color ${transitions.base};
`;

export const LabelText = styled('span')<{ $disabled: boolean }>`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${({ $disabled }) => ($disabled ? spec.labelDisabled : spec.label)};
`;
